export const RV_VALUE = Object.freeze({
  none: "none",
  ldap: "ldap",
  dynamic: "dynamic",
  list: "list",
  regexp: "regexp",
});

export default {};
